import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_check_jax_e9b1384022d2bf12c5594e4a14cbb2d9",
  "use": "icon_check_jax_e9b1384022d2bf12c5594e4a14cbb2d9-usage",
  "viewBox": "0 0 25 17",
  "content": "<symbol viewBox=\"0 0 25 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_check_jax_e9b1384022d2bf12c5594e4a14cbb2d9\">\n<path d=\"M23.569 1.29553L10.0958 14.7687L1.8003 6.47314\" stroke=\"#2CD4AE\" stroke-width=\"3\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol